// ════════════════════════════════════════════════════════════════════════════
// fmt.js — formato común de fechas, números y monedas (es-ES, hora de España)
//
// El backend guarda y devuelve las fechas en UTC. Algunas llegan sin zona
// (p. ej. "2026-10-10T09:13:48" o "2026-10-10 09:13"): se interpretan como UTC,
// nunca como hora local del navegador.
// ════════════════════════════════════════════════════════════════════════════

export const TZ = 'Europe/Madrid';
const LOCALE = 'es-ES';

const HAS_TZ = /(Z|[+-]\d{2}:?\d{2})$/i;

export function parseDate(value) {
  if (value == null || value === '') return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  if (typeof value === 'number') return new Date(value);
  let s = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) s += 'T00:00:00';
  s = s.replace(' ', 'T');
  if (!HAS_TZ.test(s)) s += 'Z';
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}

const dtFmt = new Intl.DateTimeFormat(LOCALE, {
  timeZone: TZ, day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
});
const dFmt = new Intl.DateTimeFormat(LOCALE, {
  timeZone: TZ, day: '2-digit', month: '2-digit', year: 'numeric',
});
const keyFmt = new Intl.DateTimeFormat('en-CA', {
  timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit',
});

/** "10/10/2026, 11:13" (hora de España). */
export function fmtDateTime(value, fallback = '—') {
  const d = parseDate(value);
  return d ? dtFmt.format(d) : fallback;
}

/** "10/10/2026" (fecha en España). */
export function fmtDate(value, fallback = '—') {
  const d = parseDate(value);
  return d ? dFmt.format(d) : fallback;
}

/** Clave de día "2026-10-10" según el calendario de España (para agrupar). */
export function dayKey(value) {
  const d = parseDate(value);
  return d ? keyFmt.format(d) : null;
}

/** "2.500" */
export function fmtNum(n, fallback = '—') {
  if (n == null || Number.isNaN(Number(n))) return fallback;
  return Number(n).toLocaleString(LOCALE, { useGrouping: 'always' });
}

/** "20,00 €" */
export function fmtEur(n, fallback = '—') {
  if (n == null || Number.isNaN(Number(n))) return fallback;
  return Number(n).toLocaleString(LOCALE, { style: 'currency', currency: 'EUR', useGrouping: 'always' });
}
